import { ROUTES } from '#constants/routes';
import { getQueryString } from '#utils/parseUrl';
import { origin } from '#utils/window';

export const getErrorRedirectURL = error =>
  error ? `${origin()}${ROUTES.LOGIN.path}${getQueryString({ error })}` : `${origin()}${ROUTES.LOGIN.path}`;

// Auth0 errors must have the following format: "[errorCode] - errorDescription"
export const getErrorCodeOrMessage = error => {
  const regExp = /\[(.*?)\]/;
  const matches = regExp.exec(error.message);
  return matches?.[1] || error.message;
};
